import { useMutation, useQuery } from '@apollo/client';
import { Grid } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Loader from 'Components/Forms/Loader';
import useCompanyFeatureFlags from 'FeatureModules/Auth/hooks/useCompanyFeatureFlags';
import useMessages from 'hooks/useMessages';
import Container from 'Components/PageContainer';
import DesignForm from 'FeatureModules/Setting/Components/Forms/DesignForm';
import ErrorState from 'Components/ErrorState';
import FeatureOverlay from 'Components/FeatureOverlay';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';
import { UPDATE_COMPANY_CONFIGS } from 'graphql/secure/mutations';
import { GET_COMPANY_DESIGN } from 'graphql/secure/queries';
import React, { Fragment } from 'react';
import { ECompanyFeature } from 'FeatureModules/Auth/types/company.types';
import SettingsHeader from '../Components/SettingsHeader';

const OverflowContainer = styled(Container)(() => ({
  position: 'relative',
  overflow: 'visible',
}));

const DesignSettings = () => {
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { data: { company: { design } } = {}, error, loading } = useQuery(GET_COMPANY_DESIGN);
  const { isCompanyFeatureEnabled } = useCompanyFeatureFlags();
  const designFeatureEnabled = isCompanyFeatureEnabled(ECompanyFeature.WHITE_LABELING);

  const { setSuccessMessage, setErrorMessage } = useMessages();
  const [updateCompanyConfigs] = useMutation(UPDATE_COMPANY_CONFIGS, {
    onCompleted: () => {
      setSuccessMessage('Success! Company details were updated.');
    },
    onError: () => {
      setErrorMessage('Something went wrong updating your companies details.');
    },
  });

  const handleSubmit = values => {
    return updateCompanyConfigs({
      variables: {
        input: {
          design: values,
        },
      },
    });
  };

  if (error) return <ErrorState error={error} />;
  if (!design && loading) return <Loader />;

  return (
    <Fragment>
      <OverflowContainer>
        {!designFeatureEnabled && <FeatureOverlay />}
        <SettingsHeader
          title="Branding"
          subtitle="Add your corporate identity to style your product stories."
        />
        <DesignForm onSubmit={handleSubmit} design={design} fullWidth={smallScreen}>
          {({ submitForm, isSubmitting }) => (
            <Grid container item justifyContent="flex-end" alignItems="center">
              <ThemeButton
                size="large"
                color="PRIMARY"
                loading={isSubmitting}
                type="submit"
                onClick={submitForm}
              >
                Save
              </ThemeButton>
            </Grid>
          )}
        </DesignForm>
      </OverflowContainer>
    </Fragment>
  );
};

export default DesignSettings;
